import { render, staticRenderFns } from "./NewsletterBadge.vue?vue&type=template&id=80a1e3d8&scoped=true"
import script from "./NewsletterBadge.vue?vue&type=script&lang=js"
export * from "./NewsletterBadge.vue?vue&type=script&lang=js"
import style0 from "./NewsletterBadge.vue?vue&type=style&index=0&id=80a1e3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a1e3d8",
  null
  
)

export default component.exports